module.exports = function (btsUi) {
    require('./bcbsSubMenu.js')(btsUi);
    require('./googleTagManagerAEM.js');
    btsUi.directive('headerComponent', function () {
        return {
            templateUrl: 'home.appTemplate.html/directives/headerComponent',
            scope: {
                logoImage: "@",
                overview: "@",
                planDetails: "@",
                claims: "@",
                spending: "@",
                findDoctor: "@",
                prescription: "@",
                wellness: "@"
            }
        };
    });
    btsUi.controller('headerComponentController', ['$scope', '$cookies', 'sessionData', 'brand', 'services', 'session', '$timeout', '$rootScope', '$location', '$window', 'appId', function ($scope, $cookies, sessionData, brand, services, session, $timeout, $rootScope, $location, $window, appId) {

        var headerTabs = angular.element('.headerTab .main-nav-item').not('.ng-hide');
        headerTabs.last().addClass('last-tab');
        $scope.isMINCR = brand.current.ubk === 6010;

        $scope.sliders = {};
        $scope.headerLogoClick = function (prePassUrl, postPassUrl) {
            if (sessionData.loggedIn > 0 && sessionData.basicInfo && sessionData.basicInfo.role == 'MEMBER') {
                window.location = postPassUrl;
            }
            else {
                window.location = prePassUrl;
            }
        };

        $scope.$location = $location;
        $scope.checkSubMenu = function (subMenuId, displaySubMenu, alwaysDisplaySubMenu) {
            return displaySubMenu && ($scope.displaySubMenuId === subMenuId || (alwaysDisplaySubMenu && $scope.displaySubMenuId === 'none'));
        };
        $scope.switchSubMenu = function (id) {
            //console.log($scope.displaySubMenuId, id, $scope.displaySubMenuId === id ? 'none' : id);
            // $scope.displaySubMenuId = $scope.displaySubMenuId === id ? 'none' : id;
            //$scope.displaySubMenu[id] = !$scope.displaySubMenu[id];

            if ($scope.displaySubMenuId == id) {
                if (appId === "pvdweb") {
                    delete $scope.displaySubMenuId;
                }
                else {
                    $scope.displaySubMenuId = 'none';
                }
            }
            else {
                $scope.displaySubMenuId = id;
            }
        };
        $scope.fontSize = function (size) {
            var fontSizes = ['bodyFontSmall', 'bodyFontLarge', 'bodyFontLargest'];
            angular.element(document.body).removeClass(fontSizes.join(' '));
            angular.element(document.body).addClass(fontSizes[size]);
            angular.element(document.querySelector(".btnSmall")).removeClass("font-btn-active");
            angular.element(document.querySelector(".btnLarge")).removeClass("font-btn-active");
            angular.element(document.querySelector(".btnLargest")).removeClass("font-btn-active");
            var fontSize = '';
            switch (size) {
                case 0:
                    fontSize = 'SMALL';
                    angular.element(document.querySelector(".btnSmall")).addClass("font-btn-active");
                    break;
                case 1:
                    fontSize = 'MEDIUM';
                    angular.element(document.querySelector(".btnLarge")).addClass("font-btn-active");
                    break;
                case 2:
                    fontSize = 'LARGE';
                    angular.element(document.querySelector(".btnLargest")).addClass("font-btn-active");
                    break;
            }
        };
        if (sessionData && sessionData.loggedIn && sessionData.basicInfo && sessionData.basicInfo.role == 'MEMBER') {
            $scope.medicalCount = 0;
            $scope.visionCount = 0;
            $scope.dentalCount = 0;
            $scope.showOtherPlans = false;
            $scope.showMedicalLink = false;
            $scope.showVisionLink = false;
            $scope.showDentalLink = false;
            if(sessionData.memberInfo && sessionData.memberInfo.clientList){
                for (var i = 0; i < sessionData.memberInfo.clientList.length; i++) {
                    for (var j = 0; j < sessionData.memberInfo.clientList[i].groupList.length; j++) {
                        for (var k = 0; k < sessionData.memberInfo.clientList[i].groupList[j].productList.length; k++) {
                            if (sessionData.memberInfo.clientList[i].groupList[j].productList[k].benefitPlanType === "Medical") {
                                $scope.showMedicalLink = true;
                                $scope.medicalCount++;
                            } else if (sessionData.memberInfo.clientList[i].groupList[j].productList[k].benefitPlanType === "Vision") {


                                var dtToday = new Date(),
                                    dtBeginDate = new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageBeginDate),
                                    dtEndDate = sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageCancelDate!==''?
                                        new Date (sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageCancelDate) : new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageEndDate),

                                    bCurrentlyActive = (dtBeginDate <= dtToday) && (dtEndDate >= dtToday);

                                if(bCurrentlyActive && $scope.visionCount==0){
                                    $scope.showVisionLink = true;
                                    $scope.visionCount++;
                                    $scope.visionClientNumber = sessionData.memberInfo.clientList[i].clientNumber;
                                    $scope.visionGroupNumber = sessionData.memberInfo.clientList[i].groupList[j].groupNumber;
                                    break;
                                }
                                if ($scope.visionCount==0){
                                    $scope.showVisionLink = true;
                                    $scope.visionClientNumber = sessionData.memberInfo.clientList[i].clientNumber;
                                    $scope.visionGroupNumber = sessionData.memberInfo.clientList[i].groupList[j].groupNumber;
                                }

                            } else if (sessionData.memberInfo.clientList[i].groupList[j].productList[k].benefitPlanType === "Dental") {

                                var dtToday = new Date(),
                                    dtBeginDate = new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageBeginDate),
                                    dtEndDate = sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageCancelDate!==''?
                                        new Date (sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageCancelDate) : new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageEndDate),

                                    bCurrentlyActive = (dtBeginDate <= dtToday) && (dtEndDate >= dtToday);

                                if(bCurrentlyActive && $scope.dentalCount==0){
                                    $scope.showDentalLink = true;
                                    $scope.dentalCount++;
                                    $scope.dentalClientNumber = sessionData.memberInfo.clientList[i].clientNumber;
                                    $scope.dentalGroupNumber = sessionData.memberInfo.clientList[i].groupList[j].groupNumber;
                                    break;
                                }
                                if ($scope.dentalCount==0){
                                    $scope.showDentalLink = true;
                                    $scope.dentalClientNumber = sessionData.memberInfo.clientList[i].clientNumber;
                                    $scope.dentalGroupNumber = sessionData.memberInfo.clientList[i].groupList[j].groupNumber;
                                }
                            }
                        }
                    }
                }
            }

            var value = $cookies.get("mbrViewSiteByPlanSelection");
            if (value === "true") {
                $scope.showOtherPlans = true;
                $rootScope.showOtherPlans = true;
            }

            $scope.loadMedical = function () {
                if(sessionData.memberInfo && sessionData.memberInfo.clientList){
                    for (var i = 0; i < sessionData.memberInfo.clientList.length; i++) {
                        for (var j = 0; j < sessionData.memberInfo.clientList[i].groupList.length; j++) {
                            for (var k = 0; k < sessionData.memberInfo.clientList[i].groupList[j].productList.length; k++) {
                                if (sessionData.memberInfo.clientList[i].groupList[j].productList[k].benefitPlanType === "Medical") {
                                    var bRetval = false;
                                    var dtToday = new Date(), dtBeginDate = new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageBeginDate), dtEndDate = new Date(sessionData.memberInfo.clientList[i].groupList[j].productList[k].coverageEndDate);
                                    var bCurrentlyActive = (dtBeginDate <= dtToday) && (dtEndDate >= dtToday);
                                    bRetval = bCurrentlyActive;
                                    if(bRetval){
                                        $scope.medicalGroupNumber = sessionData.memberInfo.clientList[i].groupList[j].groupNumber;
                                        $scope.medicalClientNumber = sessionData.memberInfo.clientList[i].clientNumber;
                                    }
                            }
                        }
                    }
                }
            }
                $scope.redirectURL = "/member/home";
                var theParams = {
                    clientNo: $scope.medicalClientNumber,
                    groupNo: $scope.medicalGroupNumber,
                    brand: sessionData.memberInfo.brand
                };
                services.rbsmbl.vsbpSetCookie().fetch(theParams).then(
                    function (response) {
                        if (response.data.payload.status == 'SUCCESS') {
                            services.rbsmbl.vsbpPlans().flushCache();
                            var theTarget = window.location.origin + $scope.redirectURL; //'/mbr/#!/landing'
                            window.open(theTarget, '_self');
                        }
                    });
            };
            $scope.loadVision = function () {
                $scope.redirectURL = "/member/home";
                var theParams = {
                    clientNo: $scope.visionClientNumber,
                    groupNo: $scope.visionGroupNumber,
                    brand: sessionData.memberInfo.brand
                };
                services.rbsmbl.vsbpSetCookie().fetch(theParams).then(
                    function (response) {
                        if (response.data.payload.status == 'SUCCESS') {
                            services.rbsmbl.vsbpPlans().flushCache();
                            var theTarget = window.location.origin + $scope.redirectURL; //'/mbr/#!/landing'
                            window.open(theTarget, '_self');
                        }
                    });
            };

            $scope.loadDental = function () {
                $scope.redirectURL = "/member/home";
                var theParams = {
                    clientNo: $scope.dentalClientNumber,
                    groupNo: $scope.dentalGroupNumber,
                    brand: sessionData.memberInfo.brand
                };
                services.rbsmbl.vsbpSetCookie().fetch(theParams).then(
                    function (response) {
                        if (response.data.payload.status == 'SUCCESS') {
                            services.rbsmbl.vsbpPlans().flushCache();
                            var theTarget = window.location.origin + $scope.redirectURL; //'/mbr/#!/landing'
                            window.open(theTarget, '_self');
                        }
                    });
            };
            $scope.loadOtherPlans = function () {
                $scope.showPlansURL = "/login/#/vsbp";
                var theTarget = window.location.origin + $scope.showPlansURL; //'/mbr/#!/landing'
                window.open(theTarget, '_self');
            };
        }

        //    Copied Header Tabs functionality due to time constraints. This should be component-ized.

        var body = angular.element('body');
        body.on('click', function (evt) {

            var target = body.find('.headerLoginBox');
            var buttonTarget = body.find('.login-button');
            var buttonCheck = buttonTarget[0] && buttonTarget[0].className == evt.target.className ? [1] : [] || buttonTarget.find(evt.target);
            var targetCheck = target.find(evt.target);

            if (target && buttonTarget) {
                if (!(targetCheck.length > 0 || buttonCheck.length > 0)) {
                    $scope.showMobileLoginBox = false;
                    $scope.$apply();
                }
            }

            target = body.find('.yourAccountMenu');
            buttonTarget = body.find('.yourAccountButton');
            buttonCheck = (buttonTarget[0] == evt.target || buttonTarget == evt.target) ? [1] : buttonTarget.find(evt.target);
            targetCheck = target.find(evt.target);

            if (target && buttonTarget) {
                if (!(targetCheck.length > 0 || buttonCheck.length > 0) || (!angular.element(evt.target).closest(target).length && !angular.element(evt.target).closest(buttonTarget).length)) {
                    $scope.extraOpen = false;
                    $scope.$apply();
                }
            }

            target = body.find('.headerNeedHelpParent');
            if (target) {
                if (!(target.find(evt.target).length > 0)) {
                    $scope.sliders.showNeedHelp = false;
                    $scope.$apply();
                }
            }

            target = body.find('.headerFontSizerParent');
            if (target) {
                if (!(target.find(evt.target).length > 0)) {
                    $scope.sliders.showFontSizer = false;
                    $scope.$apply();
                }
            }

            target = body.find('.headerLanguageMenuParent');
            if (target) {
                if (!(target.find(evt.target).length > 0)) {
                    $scope.showLangMenu = false;
                    $scope.$apply();
                }
            }
        });

        body.on('keydown', function (evt) {
            if (evt.which === 9 || evt.keyCode === 9) {
                $timeout(function () {
                    var target = body.find(':focus');

                    hideHeaderMenuItemIfTabbingOut(target, ['.headerNeedHelpParent'], 'showNeedHelp');
                    hideHeaderMenuItemIfTabbingOut(target, ['.headerFontSizerParent'], 'showFontSizer');
                    hideHeaderMenuItemIfTabbingOut(target, ['.headerLanguageMenuParent'], 'showLangMenu');
                    hideHeaderMenuItemIfTabbingOut(target, ['.loginBox'], 'showLoginBox');
                    hideHeaderMenuItemIfTabbingOut(target, ['.yourAccountMenu', '.yourAccountButton'], 'extraOpen');

                    $scope.$apply();
                });
            }
        });

        if($window.innerWidth < 1024){
            $scope.isDesktopTemp = false;
        }else{
            $scope.isDesktopTemp = true;
        }


        function calculateMobile() {
            $timeout(function () {
                var windowWidth = $window.innerWidth;
                var mobile = windowWidth <= 1023;
                $scope.$root.isMobileNew = mobile;
                $scope.isDesktopTemp = !mobile;
            }, 200);
        }

        function calculateResizeReload() {
            $timeout(function () {
                var windowWidth = $window.innerWidth;
                if($scope.isDesktopTemp == false){
                    if(windowWidth >= 1024){
                        $scope.isDesktopTemp = true;
                        $window.location.reload();
                    }
                }
                else{
                    if(windowWidth >= 1024){
                        var tempNode = angular.element('.sub-nav-item');
                        if (tempNode.length > 1) {
                            tempNode[0].style.display = "none";
                        }
                    }
                }
            }, 100);
        }

        calculateMobile();
        $window.addEventListener('resize', function () {
            $scope.subMenuOpen = false;
            calculateResizeReload();
            calculateMobile();
            $scope.refreshMobile = true;
            $timeout(function () {
                $scope.refreshMobile = false;
            }, 1);
        });

        /*$window.addEventListener("orientationchange", function() {
            switch ($window.orientation) {
                case -90:
                    $window.location.reload();
                    break;
                case 90:
                    $window.location.reload();
                    break;
                default:
                    break;
            }
        });*/
        var applyBlur =false;
        $scope.blurBg= function(){
            $timeout(function(){

                var getNode = angular.element(document.querySelectorAll(".aem-Grid"));
                console.log("applyBlur",applyBlur);
                if (applyBlur){
                //will need to re-evaluate the array nodes if any time in future new div with aem-Grid class are added to the page
                    getNode[0].style.filter = "blur(0px)";
                    applyBlur = false;
                }
                else{
                    getNode[1].style.filter = "blur(4px)";
                    applyBlur = true;
                }
            },20);

        };

        $timeout(function () {
            var headerTabs = angular.element('.headerTab .main-nav-item').not('.ng-hide');
            var string = $location.absUrl();
            var substring = "/find-a-doctor/landing";
            if(string.indexOf(substring)>-1 && headerTabs.length >6){
                headerTabs[6].classList.remove("defaultColorAdd");
                headerTabs[6].className += " defaultColorAdd";
            }
            var substring1 = "/find-a-doctor/home";
            if(string.indexOf(substring1)>-1 && headerTabs.length >6){
                headerTabs[6].classList.remove("defaultColorAdd");
                headerTabs[6].className += " defaultColorAdd";
            }
            var showPrescription = false;
            var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan();
            for (var a = 0; a < headerTabs.length; a++) {
                if (headerTabs[a].innerText === "Prescriptions ") {
                    headerTabs[a].style.display = "none";
                    var milliServerDate = Date.parse(new Date());
                    for(var i = 0; i < portalSelectedPlan.productList.length; i++) {
                                if(portalSelectedPlan.productList[i].coverageConBeginDate){
                                    var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageConBeginDate);
                                }else {
                                    var millisBeginDate = Date.parse(portalSelectedPlan.productList[i].coverageBeginDate);
                                }
                                var millisEndDate = Date.parse(portalSelectedPlan.productList[i].coverageEndDate);
                                var coverageIsCurrent = false;
                                coverageIsCurrent = ((millisBeginDate < milliServerDate) && (milliServerDate < millisEndDate));
                                if (coverageIsCurrent && (portalSelectedPlan.productList[i].benefitPlanType === "Drug" || portalSelectedPlan.productList[i].benefitPlanType === "PrescriptionDrug" || portalSelectedPlan.productList[i].drugCoverage === "true")) {
                                    showPrescription = true;
                                    headerTabs[a].style.display = "inline-block";
                        }
                    }
                }

                /*if (headerTabs[a].innerText === "Spending " && !sessionData.mnHasSpendingAccount) {
                    headerTabs[a].style.display = "none";
                }*/
            }
        }, 0);

        function hideHeaderMenuItemIfTabbingOut(target, menuParentClasses, menuBoolean) {
            var i = 0,
                nonHighlightedElementCount = 0;

            if ($scope[menuBoolean]) { //if dropdown is open
                for (i; i < menuParentClasses.length; i++) {
                    if (!target.closest(menuParentClasses[i]).length) {
                        nonHighlightedElementCount++;
                    }
                }
                if (nonHighlightedElementCount === menuParentClasses.length) { //if dropdown is open but no related elements are highlighted, close dropdown.
                    $scope[menuBoolean] = false;
                }
            }
        }
    }]);
};